export default __webpack_public_path__ + "static/media/iphone-12-pro.11fa8950.png";